import React from "react";
import {
  Box,
  Button,
  Divider,
  Paper,
  Stack,
} from "@mui/material";

import { EditableTable } from "../../../components/EditableTable";

// Redux Components
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logout } from "../../user/api/actions";

function BatchBillsTable(props) {
  const fieldTitles = [
    "Bill ID",
    "Account",
    "Posted",
    "Email",
    "PDF",
    "View Bill",
    "Print Bill",
    "Updated",
  ];
  const fieldTypes = [
    "labelSmall",
    "labelBold",
    "icon",
    "icon",
    "icon",
    "buttonLink",
    "icon",
    "dateTimeLabel",
  ];
  const fieldNames = [
    "accountBillId",
    "accountNum",
    "posted",
    "email",
    "pdf",
    "url",
    "printed",
    "updated",
  ];

  const batchComplete =
    props.billing.data.selectedBatch.batchSet.status == "Complete";

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <Paper
        elevation={2}
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          p: 2.5,
          borderRadius: 1,
          bgcolor: "background.paper",
          boxShadow: 2,
          boxSizing: "border-box",
        }}
      >
        {batchComplete && (
          <>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              useFlexGap
              flexWrap="wrap"
              sx={{
                alignItems: { sm: "center" },
                justifyContent: "flex-start",
                columnGap: 2,
                rowGap: 2,
              }}
            >
              <Button
                variant="contained"
                href={props.billing.data.selectedBatch.batchSet.url}
                target="_blank"
                sx={{
                  bgcolor: "grey.900",
                  color: "common.white",
                  borderRadius: 1,
                  textTransform: "none",
                  boxShadow: 1,
                  width: { xs: "100%", sm: "auto" },
                  "&:hover": { bgcolor: "grey.800" },
                }}
              >
                Download All Bills
              </Button>
              <Button
                variant="contained"
                href={props.billing.data.selectedBatch.batchSet.printedUrl}
                target="_blank"
                sx={{
                  bgcolor: "error.main",
                  color: "error.contrastText",
                  borderRadius: 1,
                  textTransform: "none",
                  boxShadow: 1,
                  width: { xs: "100%", sm: "auto" },
                  "&:hover": { bgcolor: "error.dark" },
                }}
              >
                Download Bills for Print
              </Button>
              <Button
                variant="contained"
                disabled
                onClick={() => {
                  //TODO - Reprocess Failed Bills
                }}
                sx={{
                  borderRadius: 1,
                  textTransform: "none",
                  width: { xs: "100%", sm: "auto" },
                  bgcolor: "grey.300",
                  color: "grey.600",
                  "&.Mui-disabled": {
                    bgcolor: "grey.300",
                    color: "grey.600",
                  },
                }}
              >
                Reprocess Failed Bills
              </Button>
            </Stack>
            <Divider sx={{ my: 2.5 }} />
          </>
        )}
        <EditableTable
          isLoading={
            props.billing.billingBatchDataIsLoading &&
            props.billing.data.selectedBatch.items.length == 0
          }
          tableTitle={"Bills By Batch"}
          readOnly={true}
          canAddItems={false}
          canSave={false}
          objectArray={props.billing.data.selectedBatch}
          fieldTitles={fieldTitles}
          fieldTypes={fieldTypes}
          fieldNames={fieldNames}
          showButtons={false}
          denseTable={true}
          noOuterPaper={true}
          strongTableHeaders={true}
        />
      </Paper>
    </Box>
  );
}

BatchBillsTable.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  getAllBillingDashboardInfo: PropTypes.func.isRequired,
  getBillInProgressDraft: PropTypes.func.isRequired,
  updateBillingWizardBillInProgress: PropTypes.func.isRequired,
  updateBillingWizardSelectedProperty: PropTypes.func.isRequired,
  resetBillingObject: PropTypes.func.isRequired,
  getBillingBatchById: PropTypes.func.isRequired,
};

function BatchBillsTableState(state) {
  return {
    user: state.user,
    apl: state.apl,
    billing: state.billing,
  };
}
export default connect(BatchBillsTableState, { logout })(BatchBillsTable);
